import React from 'react';
import D3Graph from './D3Graph'; // Make sure to import your D3Graph component
import { Button } from './button';
export const ThankYou = ({
  result
}:any) => {
 // Initialize your result state
  const [active, setActive] = React.useState('Ellipse Graphs'); // Initialize your active state

  return (
    <>
      {result === undefined ? (
<></>
      ) : (
        <>
<div>
<div className="grid grid-cols-12 gap-20">
  <div className=" col-span-5  ">

  <D3Graph
      results={result}
      x_axis_prefix="H2O_footprint"
                                            y_axis_prefix="Social_HHI"
    />


  </div>
  <div className=" col-span-5 ">
  <D3Graph
      results={result}
      x_axis_prefix="Price"
      y_axis_prefix="Reserve_most_critical"
    />
  </div>
</div>

<div style={{textAlignLast:"center",paddingTop:"50px"}}>

  <h1 className="text-3xl font-bold text-primary-marine-blue">Your Battery Composition Analysis is Finished!</h1>
  <p className="text-lg font-medium text-primary-marine-blue" style={{paddingTop:"15px"}}>
  <Button
  onClick={
    () => {
      window.location.reload();
      }}
								type="primary"
							>
                Simulate again
							</Button>
  </p>

</div>
</div>


        </>
      )}
    </>
  );
};
